/**
 * The primary location strip: My Documents · Shared · Archive ·
 * Trash · E-IMZO.
 *
 * Each tab is a distinct DATASET, not a filter — which is why the strip is
 * separate from the facet row below it. Conflating the two is what produced
 * the bug where choosing "Private" silently cleared "Signed".
 *
 * Purely presentational: it receives the tabs and reports clicks.
 */

import { cn } from '@/lib/utils';

import { TabPill } from './TabPill.jsx';
import { TAB_PILL_TRANSITION } from './tabPillTransition.js';

export function LocationTabs({ tabs, activeValue, className }) {
  return (
    <div className={cn('flex items-center gap-1 overflow-x-auto', className)}>
      {tabs.map((tab) => {
        const active = activeValue === tab.value;
        return (
          <button
            key={tab.value}
            type="button"
            onClick={tab.onClick}
            aria-current={active ? 'page' : undefined}
            className={cn(
              'relative flex shrink-0 items-center gap-2 whitespace-nowrap rounded-[4px]',
              'px-3.5 py-2 text-sm font-medium transition-colors cursor-pointer',
              active ? 'text-foreground' : 'text-muted-foreground hover:text-foreground',
            )}
          >
            {active && (
              <TabPill
                layoutId="docs-location-pill"
                transition={TAB_PILL_TRANSITION}
                className="absolute inset-0 rounded-[4px] bg-white shadow-sm dark:bg-background"
              />
            )}
            <span className="relative z-10 flex items-center gap-2">
              {tab.icon}
              {tab.label}
              {tab.count > 0 && (
                <span className="inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full bg-muted-foreground/15 text-[10px] font-semibold text-foreground/70">
                  {tab.count}
                </span>
              )}
            </span>
          </button>
        );
      })}
    </div>
  );
}
